import "./styles.css";
import "./base.css";
import { useEffect, useState } from "react";

/* PopUp import */
import Header from "./Header";
import Home from "./Home/Home";
import { ConsContextProvider } from "./context/ConsContext";

/* Router */
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Send from "./Send";

export default function App() {
  return (
    <div className="App">
      <ConsContextProvider>
        <BrowserRouter basename="/cotizador">
          <ScrollToTop />
          <Header />
          {/* Routes */}
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/send" element={<Send />} />
            {/* Page Not Found */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          {/* End Routes */}
        </BrowserRouter>
      </ConsContextProvider>
    </div>
  );
}
